<div class="page-container" *ngIf="formGroup$ | async as formGroup">
  <h1>Stromzähler-Befundprüfung</h1>
  <app-hint-card
    *ngIf="'commissioning.external.inspection.pageHint' | uiAdaptionVisible$ | async"
    [outlined]="true"
    [type]="'info'">
    <h2 style="color: inherit">Ihr Netzbetreiber möchte Ihnen folgende Informationen zum Antrag mitteilen</h2>
    <div [innerHTML]="'commissioning.external.inspection.pageHint' | uiAdaptionValue | safeHtmlPipe"></div>
  </app-hint-card>
  <div *ngIf="formGroup; else loading">
    Mit * markierte Felder sind Pflichtfelder!
    <form style="padding-bottom: 2em" [formGroup]="formGroup" formFocusable>
      <mat-vertical-stepper [linear]="true" #stepper>
        <mat-step [stepControl]="formGroup.controls.connectionObjectValid">
          <ng-template matStepLabel>Anschlussobjekt</ng-template>
          <section class="stepper-section">
            <app-select-gis-data
              [areaType]="AreaTypeEnum.POWER"
              [askForDevelopmentArea]="false"
              [disable]="false"
              [inputForm]="formGroup"
              [inputFormAdditionalInfo]="null"
              [listDevelopmentAreas]="[]"
              [selectedGisData]="selectedConnectionObject$ | async"
              [companyLocationsBytenant]="companyLocationsByTenant$ | async"
              [eventsFromParent]="eventsFromParent$"
              (onSelectedGisData)="onGisDataChanged($event, formGroup.controls.connectionObjectValid)" />
          </section>
          <div>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>

        <mat-step errorMessage="Bitte beheben Sie die Fehler" [stepControl]="formGroup.controls.customer">
          <ng-template matStepLabel>Kontaktdaten</ng-template>
          <section class="stepper-section">
            <app-filiation-form
              [inputFormArray]="formGroup.controls.customer"
              [id]="null"
              [selectedGisData]="selectedConnectionObject$ | async"
              [disableContractPartner]="true"></app-filiation-form>
          </section>
          <div>
            <button mat-button matStepperPrevious type="button">Zurück</button>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>

        <mat-step [stepControl]="formGroup.controls.technicalData">
          <ng-template matStepLabel>Technische Angaben</ng-template>
          <section class="stepper-section" formGroupName="technicalData">
            <form-row>
              <mat-checkbox formControlName="exceedingExpectedConsumption">
                Zeigt zu viel Verbrauch an
              </mat-checkbox>
            </form-row>
            <form-row>
              <mat-checkbox formControlName="causesNoise">Verursacht laute Geräusche</mat-checkbox>
            </form-row>
            <form-row>
              <mat-form-field appearance="outline" fxFlex="70">
                <mat-label>Sonstige Mängel oder Hinweise</mat-label>
                <textarea matInput type="text" rows="4" formControlName="comment" maxlength="255"></textarea>
              </mat-form-field>
            </form-row>
          </section>
          <div>
            <button mat-button matStepperPrevious type="button">Zurück</button>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>

        <mat-step [stepControl]="formGroup.controls.furtherInformation">
          <ng-template matStepLabel>Weitere Informationen</ng-template>
          <section class="stepper-section" formGroupName="furtherInformation">
            <label class="block-label">
              Einer notwendig werdenden Öffnung des Messgerätes im Rahmen der Befundprüfung stimme ich zu *
            </label>
            <mat-radio-group
              class="radio-group"
              formControlName="permissionToOpenDevice"
              fxLayout="row"
              fxLayoutGap="2em">
              <mat-radio-button class="radio-button" [value]="true">Ja (Regelfall)</mat-radio-button>
              <mat-radio-button class="radio-button" [value]="false">Nein (Ausnahmefall)</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="
                formGroup.controls.furtherInformation.controls.permissionToOpenDevice.touched &&
                formGroup.controls.furtherInformation.controls.permissionToOpenDevice.errors?.required
              ">
              Bitte geben Sie an, ob Sie der Öffnung des Messgerätes zustimmen.
            </mat-error>
            <div class="inspection-attendance-checkbox">
              <form-row>
                <mat-checkbox formControlName="requestsAttendance">
                  Der Auftraggeber wünscht, bei der Befundprüfung anwesend zu sein
                </mat-checkbox>
              </form-row>
            </div>
            <h2>Bedingungen</h2>
            <form-row>
              <mat-checkbox formControlName="acceptCostCondition">
                Die Kosten der Befundprüfung einer Messeinrichtung enthalten die Aufwendungen des
                Zählerwechsels und der Nachprüfung der Messeinrichtung und werden nach tatsächlichem Aufwand
                ermittelt. Ergibt die Befundprüfung, dass die Messeinrichtung nicht verwendet werden darf, so
                trägt der Messstellenbetreiber diese Kosten, sonst derjenige, der die Prüfung in Auftrag
                gegeben hat. (§ 71 Abs. 1 Messstellenbetriebsgesetz)
              </mat-checkbox>
              <mat-error
                *ngIf="
                  formGroup.controls.furtherInformation.controls.acceptCostCondition.touched &&
                  formGroup.controls.furtherInformation.controls.acceptCostCondition.invalid
                ">
                Bitte akzeptieren Sie die Bedingungen.
              </mat-error>
            </form-row>
            <form-row>
              <mat-checkbox formControlName="acceptCommissionCondition">
                Hiermit beauftrage ich/beauftragen wir {{ netOperatorName }}, die Befundprüfung der oben
                genannten Messeinrichtungen zu veranlassen. Grundlagen hierfür sind die Mess- und
                Eichverordnung (MessEV) sowie das Messstellenbetriebsgesetz (MsbG). Ich bin/Wir sind damit
                einverstanden, dass die Befundprüfung bei einer staatlich anerkannten Prüfstelle für
                Stromzähler durchgeführt wird. Ich bin/Wir sind damit einverstanden, dass die mit der
                Nachprüfung der Messeinrichtung durch eine Befundprüfung verbundenen Kosten zu meinen/unseren
                Lasten gehen, wenn die Befundprüfung ergibt, dass die Messeinrichtung verwendet werden darf.
              </mat-checkbox>
              <mat-error
                *ngIf="
                  formGroup.controls.furtherInformation.controls.acceptCommissionCondition.touched &&
                  formGroup.controls.furtherInformation.controls.acceptCommissionCondition.invalid
                ">
                Bitte akzeptieren Sie die Bedingungen.
              </mat-error>
            </form-row>
            <app-external-privacy-form-field [control]="formGroup.controls.acceptConditions" />
          </section>
          <div>
            <button mat-button matStepperPrevious type="button">Zurück</button>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>

        <mat-step *ngIf="summary$ | async as summary">
          <ng-template matStepLabel>Zusammenfassung</ng-template>
          <section class="stepper-section">
            <app-connection-object-summary
              [connectionObject]="summary.connectionObject"
              [connectionObjectAdditionalInfo]="null"></app-connection-object-summary>
          </section>
          <section>
            <app-filiation-data-summary
              [contactData]="summary.customer"
              [title]="'Kontaktdaten'"></app-filiation-data-summary>
          </section>
          <section>
            <h2>Technische Angaben</h2>
            <app-value-with-label
              [label]="'Zeigt zu viel Verbrauch an'"
              [value]="summary.actions[0]?.inspection?.exceedingExpectedConsumption ? 'Ja' : 'Nein'" />
            <app-value-with-label
              [breakLineBefore]="true"
              [label]="'Verursacht laute Geräusche'"
              [value]="summary.actions[0]?.inspection?.causesNoise ? 'Ja' : 'Nein'" />
            <app-value-with-label
              *ngIf="summary.actions[0]?.inspection?.comment"
              [breakLineBefore]="true"
              [label]="'Sonstige Mängel oder Hinweise'"
              [value]="summary.actions[0]?.inspection?.comment" />
          </section>
          <section>
            <h2>Weitere Informationen</h2>
            <app-value-with-label
              [label]="'Öffnung des Messgerätes im Rahmen der Befundprüfung'"
              [value]="
                summary.actions[0]?.inspection?.permissionToOpenDevice === true
                  ? 'Ja (Regelfall)'
                  : summary.actions[0]?.inspection?.permissionToOpenDevice === false
                  ? 'Nein (Ausnahmefall)'
                  : ''
              " />
            <app-value-with-label
              [breakLineBefore]="true"
              [label]="'Anwesenheit bei der Befundprüfung gewünscht'"
              [value]="summary.actions[0]?.inspection?.requestsAttendance ? 'Ja' : 'Nein'" />
          </section>
          <section>
            <form-row>
              <div
                class="button-container"
                fxLayout="row"
                fxLayoutAlign="space-between center"
                fxLayoutGap="20px"
                fxFlex>
                <app-custom-button
                  [title]="'Befundprüfung beantragen'"
                  (onClick)="submit(formGroup)"></app-custom-button>
              </div>
            </form-row>
          </section>
        </mat-step>
      </mat-vertical-stepper>
    </form>
  </div>

  <ng-template #loading>
    <app-loading-overlay></app-loading-overlay>
  </ng-template>
</div>
